import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { store } from 'store/store';
import { providers } from 'provider/provider.map';

import { Provider } from 'provider/provider';
import { Path } from 'components/_hooks/use-router';
import { Auth } from 'components/auth/auth';
import { AuthAppResetPass } from 'components/auth/auth-app-reset-pass';
import { AppProtected } from 'components/app/app-protected';
import { AppRedirect } from 'components/app/app-redirect';
import { TikTokModal } from 'components/tiktok/tiktok-modal';
import 'styles/global.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ReduxProvider store={store}>
    <BrowserRouter>
      <Provider providers={providers}>
        <Switch>
          <Redirect exact from={Path.root} to={Path.auth + window.location.search} />
          <Route exact path={Path.sharingTikTok} component={TikTokModal} />
          <Route path={Path.auth} component={Auth} />
          <Route path={Path.app} component={AppProtected} />
          <Route path={Path.redirect} component={AppRedirect} />
          <Route path="*" component={AppProtected} />
        </Switch>
        <AuthAppResetPass />
        <ToastContainer />
      </Provider>
    </BrowserRouter>
  </ReduxProvider>
);
